import {GameImageContainerDefaultBox} from './game-image-container.default.box';

export const GameImageContainerBox = GameImageContainerDefaultBox;